import { useLoaderData } from "react-router";
import DocumentForm from "./DocumentForm";

export default function EditVehicleDocument() {
  const document = useLoaderData();
  return <DocumentForm document={document} />;
}
